import s from './TourInfo.module.scss';

const TourInfo = ({
  detailItems = [],
  includedItems = [],
  notIncludedItems = [],
}) => {
  return (
    <aside className={s.root}>
      <section className={s.card}>
        <h2>ツアー詳細</h2>

        <dl className={s.details}>
          {detailItems.map(([label, value]) => (
            <div key={label}>
              <dt>{label}</dt>

              <dd className={label === '年齢制限' ? s.ageLimit : ''}>
                {value}
              </dd>
            </div>
          ))}
        </dl>

        {includedItems.length > 0 && (
          <>
            <div className={s.divider} />

            <div className={s.section}>
              <div className={s.sectionTitle}>
                <span className={s.includedIcon}>✓</span>
                <h3>含まれるもの</h3>
              </div>

              <ul className={s.list}>
                {includedItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </>
        )}

        {notIncludedItems.length > 0 && (
          <>
            <div className={s.divider} />

            <div className={s.section}>
              <div className={s.sectionTitle}>
                <span className={s.notIncludedIcon}>−</span>
                <h3>含まれないもの</h3>
              </div>

              <ul className={`${s.list} ${s.gray}`}>
                {notIncludedItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </>
        )}
      </section>
    </aside>
  );
};

export default TourInfo;
